const API_ERROR = 'Invalid response from API.'

export default function promiseMiddleware() {
  return next => action => {
    const {
      edition, location, promise, type, transform, params, appProps, ...rest
    } = action

    if (!promise) return next(action)

    const SUCCESS = type
    const REQUEST = type + '_REQUEST'
    const FAILURE = type + '_FAILURE'

    next({ ...rest, type: REQUEST })

    return promise
      .then(res => {
        let data = {}
        let error

        if(!res) {
          error = Error(API_ERROR)
          next({ ...rest, error : error, type: FAILURE })
          throw error
        }
        if(typeof transform === 'function') {
          data = transform({ res, edition, params, location, appProps })
        }
        next({ ...rest, edition, params, location, data, res, type: SUCCESS })
        return true
      })
  }
}



// WEBPACK FOOTER //
// ./lib/promiseMiddleware.js